import {KinesisEvent} from "../kinesis.event";
import {KINESIS} from "../../kinesis.consts";

export class WizardTeamSelectionSkipKinesisEvent extends KinesisEvent {
  constructor(properties) {
    super(
      KINESIS.CATEGORY.bolao,
      KINESIS.ACTION.wizard,
      KINESIS.LABEL.teamSelection,
      KINESIS.VALUE.skip,
      properties
    );
  }

  getProperties(params) {
    const props = super.getProperties()

    return {
      ...props,
      competitor_id: params?.id || null
    }
  }
}
